import RightSidebarButton from "@/features/Navigation/components/RightSidebarButton";
import { ArrowDownTrayIcon } from "@heroicons/react/24/outline";
import clsx from "clsx";
import FileLineageTree from "@/features/FileManagement/components/FileLineageTree";
import { nodes } from "@/features/FileManagement/components/FileLineageTree/FileLineageTree";

export function ConnectorPanel() {
    return (
        <div
            className={clsx(
                "px-6",
                "absolute inset-0 flex min-h-0 flex-col overflow-hidden",
            )}
        >
            <div className="sticky my-6 flex flex-col">
                <RightSidebarButton />
                <h1 className="pageheading break-all">
                    raw_20251028154810_xero_balance_sheet_json.avro
                </h1>
                <button
                    className={clsx(
                        "w-fit",
                        "link quiet flex items-center gap-1",
                    )}
                    onClick={() => {}}
                >
                    Download <ArrowDownTrayIcon className="size-4" />
                </button>
            </div>
            <div className="custom-scrollbar hide-scrollbar overflow-y-scroll pb-6">
                <FileLineageTree nodes={nodes} />
            </div>
        </div>
    );
}
